// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__wOT9c","footer":"ModalUpdate_footer__3GLC7"};